module.exports = __webpack_public_path__ + "media/images/sales/live-endroll/text-mv-duedate-year-2028-50db74294f609546d2c099a699de10bd.svg";